import React, { useState, useEffect } from 'react'
import { Grid, TextField } from '@mui/material'
import { Autocomplete } from '@mui/material'

const ModuleSelector = ({ moduleOptions, roleOptions, defaultModule, defaultRole, onChange, id, loading }) => {
    const [_module, setModule] = useState()
    const [role, setRole] = useState(defaultRole)

    useEffect(() => {
        setModule(moduleOptions.find(m => m.value === defaultModule))
    }, [moduleOptions])

    return (
        <Grid container spacing={8} alignItems="center">
            <Grid item xs={6}>
                <Autocomplete
                    disableClearable
                    ChipProps={{ size: 'small' }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    getOptionLabel={option => option?.label ?? ''}
                    renderInput={params => <TextField placeholder="Select module..." {...params} />}
                    options={moduleOptions}
                    value={_module ?? ''}
                    onChange={(e, m) => {
                        onChange(m.value, id, 'module')
                        setRole(null)
                        setModule(m)
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <Autocomplete
                    disableClearable
                    ChipProps={{ size: 'small' }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    getOptionLabel={option => option?.label ?? ''}
                    renderInput={params => <TextField placeholder="Select role..." {...params} />}
                    options={roleOptions}
                    value={role ?? ''}
                    onChange={(e, role) => {
                        onChange(role.value, id)
                        setRole(role)
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default ModuleSelector
